"use strict";module.exports=require("apps/web/client/core/winston");